export default __webpack_public_path__ + "static/media/icon-like-poppy-active.31a9fe05.png";